/**
 * countries
 */
export type Country =
  | 'HUNGARY'
  | 'AFGHANISTAN'
  | 'ALAND'
  | 'ALBANIA'
  | 'ALGERIA'
  | 'USA'
  | 'AMERICAN_SAMOA'
  | 'US_VIRGIN_ISLANDS'
  | 'ANDORRA'
  | 'ENGLAND'
  | 'ANGOLA'
  | 'ANGUILLA'
  | 'ANTARCTICA'
  | 'ANTIGUA_AND_BARBUDA'
  | 'ARGENTINA'
  | 'ARUBA'
  | 'AUSTRALIA'
  | 'AUSTRIA'
  | 'AZERBAIJAN'
  | 'BAHAMA_ISLANDS'
  | 'BAHRAIN'
  | 'BANGLADESH'
  | 'BARBADOS'
  | 'BELGIUM'
  | 'BELIZE'
  | 'IN_BENIN'
  | 'BERMUDA'
  | 'BHUTAN'
  | 'GUINEA_BISSAU'
  | 'BOLIVIA'
  | 'BOSNIA_AND_HERZEGOVINA'
  | 'BOTSWANA'
  | 'BRAZIL'
  | 'BRITISH_INDIAN_OCEAN_TERRITORY'
  | 'BRITISH_VIRGIN_ISLANDS'
  | 'BRUNEI'
  | 'BULGARIA'
  | 'BURKINA_FASO'
  | 'BURUNDI'
  | 'CHILE'
  | 'CYPRUS'
  | 'COMOROS_ISLANDS'
  | 'COOK_ISLANDS'
  | 'COSTA_RICA'
  | 'CURACAO'
  | 'CHAD'
  | 'CZECH_REPUBLIC'
  | 'DENMARK'
  | 'REPUBLIC_OF_SOUTH_AFRICA'
  | 'SOUTH_GEORGIA_AND_SOUTH_SANDWICH_ISLANDS'
  | 'SOUTH_KOREA_REPUBLIC_OF_KOREA'
  | 'SOUTH_SUDAN'
  | 'DOMINICAN_COMMUNITY'
  | 'DOMINICAN_REPUBLIC'
  | 'DJIBOUTI'
  | 'ECUADOR'
  | 'EQUATORIAL_GUINEA'
  | 'UNITED_ARAB_EMIRATES'
  | 'EGYPT'
  | 'IVORY_COAST'
  | 'ERITREA'
  | 'NORTHERN_MARIANA_ISLANDS'
  | 'NORTH_IRELAND'
  | 'NORTH_KOREA_DPRK'
  | 'NORTH_MACEDONIA'
  | 'ESTONIA'
  | 'ETHIOPIA'
  | 'FALKLAND_ISLANDS'
  | 'BELARUS'
  | 'FAROESE'
  | 'FIJI'
  | 'FINLAND'
  | 'FRENCH_SOUTHERN_AND_ANTARCTIC_TERRITORIES'
  | 'FRENCH_GUIANA_FRENCH_GUIANA'
  | 'FRENCH_POLYNESIA'
  | 'FRANCE'
  | 'PHILIPPINES'
  | 'GABON'
  | 'GAMBIA'
  | 'GHANA'
  | 'GIBRALTAR'
  | 'GREECE'
  | 'GRENADE'
  | 'GREENLAND'
  | 'GEORGIA'
  | 'GUADELOUPE_GUADELOUPE'
  | 'GUAM'
  | 'GUATEMALA'
  | 'BAILIFFSHIP_OF_GUERNSEY'
  | 'GUINEA'
  | 'GUIANA'
  | 'HAITI'
  | 'HEARD_ISLAND_AND_MCDONALD_ISLANDS'
  | 'THE_NETHERLANDS'
  | 'HONDURAS'
  | 'HONG_KONG'
  | 'CROATIA'
  | 'INDIA'
  | 'INDONESIA'
  | 'IRAQ'
  | 'IRAN'
  | 'IRELAND'
  | 'ICELAND'
  | 'ISRAEL'
  | 'JAMAICA'
  | 'JAPAN'
  | 'YEMEN'
  | 'BAILIFFSHIP_OF_JERSEY'
  | 'JORDAN'
  | 'CAYMAN_ISLANDS'
  | 'CAMBODIA'
  | 'CAMEROON'
  | 'CANADA'
  | 'CHRISTMAS_ISLAND'
  | 'CARIBBEAN_NETHERLANDS_BONAIRE_SABA_SINT_EUSTATIUS'
  | 'QATAR'
  | 'KAZAKHSTAN'
  | 'EAST_TIMOR'
  | 'KENYA'
  | 'CHINA'
  | 'KYRGYZSTAN'
  | 'KIRIBATI'
  | 'COCOS_KEELING_ISLANDS'
  | 'COLOMBIA'
  | 'DEMOCRATIC_REPUBLIC_OF_THE_CONGO_ZAIRE'
  | 'REPUBLIC_OF_THE_CONGO_CONGO'
  | 'KOSOVO'
  | 'CENTRAL_AFRICA'
  | 'CUBA'
  | 'KUWAIT'
  | 'LAOS'
  | 'POLAND'
  | 'LESOTHO'
  | 'LATVIA'
  | 'LEBANON'
  | 'LIBERIA'
  | 'LIBYA'
  | 'LIECHTENSTEIN'
  | 'LITHUANIA'
  | 'LUXEMBOURG'
  | 'MADAGASCAR'
  | 'MACAU'
  | 'MALAYSIA'
  | 'MALAWI'
  | 'MALDIVES'
  | 'MALI'
  | 'MALTA'
  | 'MAN'
  | 'MOROCCO'
  | 'MARSHALL_ISLANDS'
  | 'MARTINIQUE_MARTINIQUE'
  | 'MAURITANIA'
  | 'MAURITIUS'
  | 'MAYOTTE_MAYOTTE'
  | 'MEXICO'
  | 'MYANMAR'
  | 'MICRONESIA'
  | 'MOLDOVA'
  | 'MONACO'
  | 'MONGOLIA'
  | 'MONTENEGRO'
  | 'MONTSERRAT'
  | 'MOZAMBIQUE'
  | 'NAMIBIA'
  | 'NAURU'
  | 'GERMANY'
  | 'NEPAL'
  | 'NICARAGUA'
  | 'NIGER'
  | 'NIGERIA'
  | 'NIUE'
  | 'NORFOLK_ISLAND'
  | 'NORWAY'
  | 'NORWAY_BOUVET_ISLAND'
  | 'NORWAY_SPITSBERGEN_AND_JAN_MAYEN_ISLAND'
  | 'WESTERN_SAHARA'
  | 'ITALY'
  | 'OMAN'
  | 'RUSSIA'
  | 'ARMENIA'
  | 'PAKISTAN'
  | 'PALAU'
  | 'PALESTINE'
  | 'PANAMA'
  | 'PAPUA_NEW_GUINEA'
  | 'PARAGUAY'
  | 'PERU'
  | 'PITCAIRN_ISLANDS'
  | 'PORTUGAL'
  | 'PUERTO_RICO'
  | 'REUNION'
  | 'ROMANIA'
  | 'RWANDA'
  | 'SAINT_KITTS_AND_NEVIS'
  | 'SAINT_LUCIA'
  | 'SAINT_VINCENT_AND_THE_GRENADINES'
  | 'SAINT_BARTHELEMY'
  | 'SAINT_MARTIN'
  | 'SAINT_PIERRE_AND_MIQUELON_SAINT_PIERRE_AND_MIQUELON'
  | 'SCOTLAND'
  | 'SOLOMON_ISLANDS'
  | 'SALVADOR'
  | 'SAN_MARINO'
  | 'SAO_TOME_AND_PRINCIPE'
  | 'SEYCHELLES_ISLANDS'
  | 'SIERRA_LEONE'
  | 'SINT_MAARTEN'
  | 'SPAIN'
  | 'SRI_LANKA'
  | 'SURINAME'
  | 'SWITZERLAND'
  | 'SWEDEN'
  | 'SAMOA'
  | 'SAUDI_ARABIA'
  | 'SENEGAL'
  | 'SAINT_HELENA'
  | 'SERBIA'
  | 'SERBIA_AND_MONTENEGRO'
  | 'SINGAPORE'
  | 'SYRIA'
  | 'SLOVAKIA'
  | 'SLOVENIA'
  | 'SOMALIA'
  | 'SUDAN'
  | 'SWAZILAND'
  | 'TAJIKISTAN'
  | 'TAIWAN'
  | 'TANZANIA'
  | 'THAILAND'
  | 'TOGO'
  | 'TOKELAU_ISLANDS'
  | 'TONGA'
  | 'TURKEY'
  | 'TRINIDAD_AND_TOBAGO'
  | 'TUNISIA'
  | 'TURKS_AND_CAICOS_ISLANDS'
  | 'TUVALU'
  | 'TURKMENISTAN'
  | 'UGANDA'
  | 'NEW_CALEDONIA'
  | 'NEW_ZEALAND'
  | 'UKRAINE'
  | 'URUGUAY'
  | 'USA_AMERICAN_PACIFIC_ISLANDS'
  | 'UZBEKISTAN'
  | 'VANUATU'
  | 'VATICAN'
  | 'VENEZUELA'
  | 'VIETNAM'
  | 'WALES'
  | 'WALLIS_AND_FUTUNA_WALLIS_AND_FUTUNA'
  | 'ZAMBIA'
  | 'ZIMBABWE'
  | 'GREEN_VERDE';

export const Country = {
  Hungary: 'HUNGARY' as Country,
  Afghanistan: 'AFGHANISTAN' as Country,
  Aland: 'ALAND' as Country,
  Albania: 'ALBANIA' as Country,
  Algeria: 'ALGERIA' as Country,
  Usa: 'USA' as Country,
  AmericanSamoa: 'AMERICAN_SAMOA' as Country,
  UsVirginIslands: 'US_VIRGIN_ISLANDS' as Country,
  Andorra: 'ANDORRA' as Country,
  England: 'ENGLAND' as Country,
  Angola: 'ANGOLA' as Country,
  Anguilla: 'ANGUILLA' as Country,
  Antarctica: 'ANTARCTICA' as Country,
  AntiguaAndBarbuda: 'ANTIGUA_AND_BARBUDA' as Country,
  Argentina: 'ARGENTINA' as Country,
  Aruba: 'ARUBA' as Country,
  Australia: 'AUSTRALIA' as Country,
  Austria: 'AUSTRIA' as Country,
  Azerbaijan: 'AZERBAIJAN' as Country,
  BahamaIslands: 'BAHAMA_ISLANDS' as Country,
  Bahrain: 'BAHRAIN' as Country,
  Bangladesh: 'BANGLADESH' as Country,
  Barbados: 'BARBADOS' as Country,
  Belgium: 'BELGIUM' as Country,
  Belize: 'BELIZE' as Country,
  InBenin: 'IN_BENIN' as Country,
  Bermuda: 'BERMUDA' as Country,
  Bhutan: 'BHUTAN' as Country,
  GuineaBissau: 'GUINEA_BISSAU' as Country,
  Bolivia: 'BOLIVIA' as Country,
  BosniaAndHerzegovina: 'BOSNIA_AND_HERZEGOVINA' as Country,
  Botswana: 'BOTSWANA' as Country,
  Brazil: 'BRAZIL' as Country,
  BritishIndianOceanTerritory: 'BRITISH_INDIAN_OCEAN_TERRITORY' as Country,
  BritishVirginIslands: 'BRITISH_VIRGIN_ISLANDS' as Country,
  Brunei: 'BRUNEI' as Country,
  Bulgaria: 'BULGARIA' as Country,
  BurkinaFaso: 'BURKINA_FASO' as Country,
  Burundi: 'BURUNDI' as Country,
  Chile: 'CHILE' as Country,
  Cyprus: 'CYPRUS' as Country,
  ComorosIslands: 'COMOROS_ISLANDS' as Country,
  CookIslands: 'COOK_ISLANDS' as Country,
  CostaRica: 'COSTA_RICA' as Country,
  Curacao: 'CURACAO' as Country,
  Chad: 'CHAD' as Country,
  CzechRepublic: 'CZECH_REPUBLIC' as Country,
  Denmark: 'DENMARK' as Country,
  RepublicOfSouthAfrica: 'REPUBLIC_OF_SOUTH_AFRICA' as Country,
  SouthGeorgiaAndSouthSandwichIslands:
    'SOUTH_GEORGIA_AND_SOUTH_SANDWICH_ISLANDS' as Country,
  SouthKoreaRepublicOfKorea: 'SOUTH_KOREA_REPUBLIC_OF_KOREA' as Country,
  SouthSudan: 'SOUTH_SUDAN' as Country,
  DominicanCommunity: 'DOMINICAN_COMMUNITY' as Country,
  DominicanRepublic: 'DOMINICAN_REPUBLIC' as Country,
  Djibouti: 'DJIBOUTI' as Country,
  Ecuador: 'ECUADOR' as Country,
  EquatorialGuinea: 'EQUATORIAL_GUINEA' as Country,
  UnitedArabEmirates: 'UNITED_ARAB_EMIRATES' as Country,
  Egypt: 'EGYPT' as Country,
  IvoryCoast: 'IVORY_COAST' as Country,
  Eritrea: 'ERITREA' as Country,
  NorthernMarianaIslands: 'NORTHERN_MARIANA_ISLANDS' as Country,
  NorthIreland: 'NORTH_IRELAND' as Country,
  NorthKoreaDprk: 'NORTH_KOREA_DPRK' as Country,
  NorthMacedonia: 'NORTH_MACEDONIA' as Country,
  Estonia: 'ESTONIA' as Country,
  Ethiopia: 'ETHIOPIA' as Country,
  FalklandIslands: 'FALKLAND_ISLANDS' as Country,
  Belarus: 'BELARUS' as Country,
  Faroese: 'FAROESE' as Country,
  Fiji: 'FIJI' as Country,
  Finland: 'FINLAND' as Country,
  FrenchSouthernAndAntarcticTerritories:
    'FRENCH_SOUTHERN_AND_ANTARCTIC_TERRITORIES' as Country,
  FrenchGuianaFrenchGuiana: 'FRENCH_GUIANA_FRENCH_GUIANA' as Country,
  FrenchPolynesia: 'FRENCH_POLYNESIA' as Country,
  France: 'FRANCE' as Country,
  Philippines: 'PHILIPPINES' as Country,
  Gabon: 'GABON' as Country,
  Gambia: 'GAMBIA' as Country,
  Ghana: 'GHANA' as Country,
  Gibraltar: 'GIBRALTAR' as Country,
  Greece: 'GREECE' as Country,
  Grenade: 'GRENADE' as Country,
  Greenland: 'GREENLAND' as Country,
  Georgia: 'GEORGIA' as Country,
  GuadeloupeGuadeloupe: 'GUADELOUPE_GUADELOUPE' as Country,
  Guam: 'GUAM' as Country,
  Guatemala: 'GUATEMALA' as Country,
  BailiffshipOfGuernsey: 'BAILIFFSHIP_OF_GUERNSEY' as Country,
  Guinea: 'GUINEA' as Country,
  Guiana: 'GUIANA' as Country,
  Haiti: 'HAITI' as Country,
  HeardIslandAndMcdonaldIslands: 'HEARD_ISLAND_AND_MCDONALD_ISLANDS' as Country,
  TheNetherlands: 'THE_NETHERLANDS' as Country,
  Honduras: 'HONDURAS' as Country,
  HongKong: 'HONG_KONG' as Country,
  Croatia: 'CROATIA' as Country,
  India: 'INDIA' as Country,
  Indonesia: 'INDONESIA' as Country,
  Iraq: 'IRAQ' as Country,
  Iran: 'IRAN' as Country,
  Ireland: 'IRELAND' as Country,
  Iceland: 'ICELAND' as Country,
  Israel: 'ISRAEL' as Country,
  Jamaica: 'JAMAICA' as Country,
  Japan: 'JAPAN' as Country,
  Yemen: 'YEMEN' as Country,
  BailiffshipOfJersey: 'BAILIFFSHIP_OF_JERSEY' as Country,
  Jordan: 'JORDAN' as Country,
  CaymanIslands: 'CAYMAN_ISLANDS' as Country,
  Cambodia: 'CAMBODIA' as Country,
  Cameroon: 'CAMEROON' as Country,
  Canada: 'CANADA' as Country,
  ChristmasIsland: 'CHRISTMAS_ISLAND' as Country,
  CaribbeanNetherlandsBonaireSabaSintEustatius:
    'CARIBBEAN_NETHERLANDS_BONAIRE_SABA_SINT_EUSTATIUS' as Country,
  Qatar: 'QATAR' as Country,
  Kazakhstan: 'KAZAKHSTAN' as Country,
  EastTimor: 'EAST_TIMOR' as Country,
  Kenya: 'KENYA' as Country,
  China: 'CHINA' as Country,
  Kyrgyzstan: 'KYRGYZSTAN' as Country,
  Kiribati: 'KIRIBATI' as Country,
  CocosKeelingIslands: 'COCOS_KEELING_ISLANDS' as Country,
  Colombia: 'COLOMBIA' as Country,
  DemocraticRepublicOfTheCongoZaire:
    'DEMOCRATIC_REPUBLIC_OF_THE_CONGO_ZAIRE' as Country,
  RepublicOfTheCongoCongo: 'REPUBLIC_OF_THE_CONGO_CONGO' as Country,
  Kosovo: 'KOSOVO' as Country,
  CentralAfrica: 'CENTRAL_AFRICA' as Country,
  Cuba: 'CUBA' as Country,
  Kuwait: 'KUWAIT' as Country,
  Laos: 'LAOS' as Country,
  Poland: 'POLAND' as Country,
  Lesotho: 'LESOTHO' as Country,
  Latvia: 'LATVIA' as Country,
  Lebanon: 'LEBANON' as Country,
  Liberia: 'LIBERIA' as Country,
  Libya: 'LIBYA' as Country,
  Liechtenstein: 'LIECHTENSTEIN' as Country,
  Lithuania: 'LITHUANIA' as Country,
  Luxembourg: 'LUXEMBOURG' as Country,
  Madagascar: 'MADAGASCAR' as Country,
  Macau: 'MACAU' as Country,
  Malaysia: 'MALAYSIA' as Country,
  Malawi: 'MALAWI' as Country,
  Maldives: 'MALDIVES' as Country,
  Mali: 'MALI' as Country,
  Malta: 'MALTA' as Country,
  Man: 'MAN' as Country,
  Morocco: 'MOROCCO' as Country,
  MarshallIslands: 'MARSHALL_ISLANDS' as Country,
  MartiniqueMartinique: 'MARTINIQUE_MARTINIQUE' as Country,
  Mauritania: 'MAURITANIA' as Country,
  Mauritius: 'MAURITIUS' as Country,
  MayotteMayotte: 'MAYOTTE_MAYOTTE' as Country,
  Mexico: 'MEXICO' as Country,
  Myanmar: 'MYANMAR' as Country,
  Micronesia: 'MICRONESIA' as Country,
  Moldova: 'MOLDOVA' as Country,
  Monaco: 'MONACO' as Country,
  Mongolia: 'MONGOLIA' as Country,
  Montenegro: 'MONTENEGRO' as Country,
  Montserrat: 'MONTSERRAT' as Country,
  Mozambique: 'MOZAMBIQUE' as Country,
  Namibia: 'NAMIBIA' as Country,
  Nauru: 'NAURU' as Country,
  Germany: 'GERMANY' as Country,
  Nepal: 'NEPAL' as Country,
  Nicaragua: 'NICARAGUA' as Country,
  Niger: 'NIGER' as Country,
  Nigeria: 'NIGERIA' as Country,
  Niue: 'NIUE' as Country,
  NorfolkIsland: 'NORFOLK_ISLAND' as Country,
  Norway: 'NORWAY' as Country,
  NorwayBouvetIsland: 'NORWAY_BOUVET_ISLAND' as Country,
  NorwaySpitsbergenAndJanMayenIsland:
    'NORWAY_SPITSBERGEN_AND_JAN_MAYEN_ISLAND' as Country,
  WesternSahara: 'WESTERN_SAHARA' as Country,
  Italy: 'ITALY' as Country,
  Oman: 'OMAN' as Country,
  Russia: 'RUSSIA' as Country,
  Armenia: 'ARMENIA' as Country,
  Pakistan: 'PAKISTAN' as Country,
  Palau: 'PALAU' as Country,
  Palestine: 'PALESTINE' as Country,
  Panama: 'PANAMA' as Country,
  PapuaNewGuinea: 'PAPUA_NEW_GUINEA' as Country,
  Paraguay: 'PARAGUAY' as Country,
  Peru: 'PERU' as Country,
  PitcairnIslands: 'PITCAIRN_ISLANDS' as Country,
  Portugal: 'PORTUGAL' as Country,
  PuertoRico: 'PUERTO_RICO' as Country,
  Reunion: 'REUNION' as Country,
  Romania: 'ROMANIA' as Country,
  Rwanda: 'RWANDA' as Country,
  SaintKittsAndNevis: 'SAINT_KITTS_AND_NEVIS' as Country,
  SaintLucia: 'SAINT_LUCIA' as Country,
  SaintVincentAndTheGrenadines: 'SAINT_VINCENT_AND_THE_GRENADINES' as Country,
  SaintBarthelemy: 'SAINT_BARTHELEMY' as Country,
  SaintMartin: 'SAINT_MARTIN' as Country,
  SaintPierreAndMiquelonSaintPierreAndMiquelon:
    'SAINT_PIERRE_AND_MIQUELON_SAINT_PIERRE_AND_MIQUELON' as Country,
  Scotland: 'SCOTLAND' as Country,
  SolomonIslands: 'SOLOMON_ISLANDS' as Country,
  Salvador: 'SALVADOR' as Country,
  SanMarino: 'SAN_MARINO' as Country,
  SaoTomeAndPrincipe: 'SAO_TOME_AND_PRINCIPE' as Country,
  SeychellesIslands: 'SEYCHELLES_ISLANDS' as Country,
  SierraLeone: 'SIERRA_LEONE' as Country,
  SintMaarten: 'SINT_MAARTEN' as Country,
  Spain: 'SPAIN' as Country,
  SriLanka: 'SRI_LANKA' as Country,
  Suriname: 'SURINAME' as Country,
  Switzerland: 'SWITZERLAND' as Country,
  Sweden: 'SWEDEN' as Country,
  Samoa: 'SAMOA' as Country,
  SaudiArabia: 'SAUDI_ARABIA' as Country,
  Senegal: 'SENEGAL' as Country,
  SaintHelena: 'SAINT_HELENA' as Country,
  Serbia: 'SERBIA' as Country,
  SerbiaAndMontenegro: 'SERBIA_AND_MONTENEGRO' as Country,
  Singapore: 'SINGAPORE' as Country,
  Syria: 'SYRIA' as Country,
  Slovakia: 'SLOVAKIA' as Country,
  Slovenia: 'SLOVENIA' as Country,
  Somalia: 'SOMALIA' as Country,
  Sudan: 'SUDAN' as Country,
  Swaziland: 'SWAZILAND' as Country,
  Tajikistan: 'TAJIKISTAN' as Country,
  Taiwan: 'TAIWAN' as Country,
  Tanzania: 'TANZANIA' as Country,
  Thailand: 'THAILAND' as Country,
  Togo: 'TOGO' as Country,
  TokelauIslands: 'TOKELAU_ISLANDS' as Country,
  Tonga: 'TONGA' as Country,
  Turkey: 'TURKEY' as Country,
  TrinidadAndTobago: 'TRINIDAD_AND_TOBAGO' as Country,
  Tunisia: 'TUNISIA' as Country,
  TurksAndCaicosIslands: 'TURKS_AND_CAICOS_ISLANDS' as Country,
  Tuvalu: 'TUVALU' as Country,
  Turkmenistan: 'TURKMENISTAN' as Country,
  Uganda: 'UGANDA' as Country,
  NewCaledonia: 'NEW_CALEDONIA' as Country,
  NewZealand: 'NEW_ZEALAND' as Country,
  Ukraine: 'UKRAINE' as Country,
  Uruguay: 'URUGUAY' as Country,
  UsaAmericanPacificIslands: 'USA_AMERICAN_PACIFIC_ISLANDS' as Country,
  Uzbekistan: 'UZBEKISTAN' as Country,
  Vanuatu: 'VANUATU' as Country,
  Vatican: 'VATICAN' as Country,
  Venezuela: 'VENEZUELA' as Country,
  Vietnam: 'VIETNAM' as Country,
  Wales: 'WALES' as Country,
  WallisAndFutunaWallisAndFutuna:
    'WALLIS_AND_FUTUNA_WALLIS_AND_FUTUNA' as Country,
  Zambia: 'ZAMBIA' as Country,
  Zimbabwe: 'ZIMBABWE' as Country,
  GreenVerde: 'GREEN_VERDE' as Country,
};
